import { XERO_INVOICING_REPORTS } from '../types';

const initialState = {
  loading: true,
  reports: [],
};

const xeroInvoicingReportsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case XERO_INVOICING_REPORTS.LOADING_START:
      return {
        ...state,
        reports: [],
        loading: true,
      };
    case XERO_INVOICING_REPORTS.FETCH_SUCCESS:
      return {
        ...state,
        reports: payload,
        loading: false,
      };
    case XERO_INVOICING_REPORTS.FETCH_FAILED:
      return {
        ...state,
        reports: [],
        loading: false,
      };

    default: {
      return state;
    }
  }
};

export default xeroInvoicingReportsReducer;
